import React from 'react';
import { AuthProvider, type AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import AuthService from '../../Services/AuthService';

interface PropTypes {
  children: React.ReactElement;
}

// BHP-1040: OIDC client against Authentik (authorization code + PKCE).
// Config comes entirely from env via AuthService; oidc-client-ts adds PKCE
// automatically for `response_type: 'code'`. Callback handling and the sign-in/
// sign-out UX are (re)built in BHP-1042.
const authConfig = new AuthService().getAuthConfig();

const oidcConfig: AuthProviderProps = {
  authority: authConfig.authority,
  client_id: authConfig.clientId,
  redirect_uri: authConfig.redirectUri,
  scope: authConfig.scope,
  response_type: 'code',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // After a successful sign-in, drop the ?code&state params and leave the OIDC
  // redirect path (/callback) by landing on the app (BHP-1042).
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, '/dashboard');
  }
};

export default function AuthConfigProvider({
  children
}: PropTypes): JSX.Element {
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}
